export default {
    CHANGE_THEME: "theme/CHANGE_THEME",
}